import { useEffect } from 'react';
import { APP_CONFIG } from '../config/app';
import Hero from '../components/Hero';
import Pricing from '../components/Pricing';
import Team from '../components/Team';
import Faq from '../components/Faq';
import GoogleReviewsWidget from '../components/GoogleReviewsWidget';
import CoverageContactSection from '../components/CoverageContactSection';
import ClientSpaceSection from '../components/ClientSpaceSection';

const HomePage = () => {
  useEffect(() => {
    document.title = APP_CONFIG.title;
  }, []);

  return (
    <>
      <Hero />
      <CoverageContactSection />
      <Pricing />
      <ClientSpaceSection />
      <Team />
      <GoogleReviewsWidget />
      <Faq />
    </>
  );
};

export default HomePage;
